"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _decorators = require("../utils/propTypes/decorators");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-image: none !important;\n  position: relative;\n\n  &::before {\n    content: ' ';\n    ", ";\n    background-repeat: repeat-y;\n    position: absolute;\n    ", ": ", ";\n    top: 0;\n    width: ", ";\n    height: calc(100% - ", ");\n    max-height: ", "px;\n    margin: ", " 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  line-height: ", ";\n  min-width: ", ";\n\n  /* By using hidden content instead of fixed height, we inherit line-height, vertical-align, etc. */\n  &::after {\n    content: '.';\n    visibility: hidden;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      background-position: ", " calc(50% + 1px);\n      background-repeat: no-repeat;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      background-image: url(\"data:image/svg+xml,", "\");\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var emptyBox = _react.default.createElement("span", null);

var maxHeightForSize = {
  sm: 10,
  md: 50,
  lg: 90
};
var getGrippieBackground = (0, _memoize.default)(function (fill) {
  var svgStr = "<svg width='" + _sizes.DRAG_HANDLE_WIDTH + "' height='" + _sizes.DRAG_HANDLE_HEIGHT + "' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 " + _sizes.DRAG_HANDLE_WIDTH + " " + _sizes.DRAG_HANDLE_HEIGHT + "'><path fill='" + fill + "' d='M0 0h2v2H0V0zm0 8h2v2H0V8zm0 8h2v2H0v-2zM0 4h2v2H0V4zm0 8h2v2H0v-2zm0 8h2v2H0v-2zM3 0h2v2H3V0zm0 8h2v2H3V8zm0 8h2v2H3v-2zM3 4h2v2H3V4zm0 8h2v2H3v-2zm0 8h2v2H3v-2z'/></svg>";
  return (0, _styledComponents.css)(_templateObject(), encodeURIComponent(svgStr));
});
var getGrippieOffset = (0, _memoize.default)(function (offsetX) {
  return (0, _styledComponents.css)(_templateObject2(), offsetX);
});
var standaloneMixin = (0, _styledComponents.css)(_templateObject3(), _sizes.BASE_LINE_HEIGHT, _sizes.DRAG_HANDLE_WIDTH);
var sizedMixin = (0, _styledComponents.css)(_templateObject4(), getGrippieBackground(_colors.SLINKY), function (_ref) {
  var trailing = _ref.trailing;
  return trailing ? 'right' : 'left';
}, _sizes.DRAG_HANDLE_OFFSET_X, _sizes.DRAG_HANDLE_WIDTH, _sizes.DRAG_HANDLE_HEIGHT, function (_ref2) {
  var size = _ref2.size;
  return maxHeightForSize[size];
}, _sizes.DRAG_HANDLE_OFFSET_Y);
var DragHandleChild = (0, _styledComponents.default)(function (_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      rest = _ref3.rest;
  return (0, _react.cloneElement)(children, (0, _extends2.default)({
    className: (0, _classNames.default)(children.props.className, className)
  }, rest));
}).withConfig({
  displayName: "UIDragHandle__DragHandleChild",
  componentId: "sc-1kdlv1a-0"
})(_templateObject5(), (0, _Styles.setGrabCursor)(), function (_ref4) {
  var use = _ref4.use;
  return getGrippieBackground(use === 'on-dark' ? _colors.OLAF : _colors.SLINKY);
}, function (_ref5) {
  var standalone = _ref5.standalone,
      trailing = _ref5.trailing;
  var offsetX = _sizes.DRAG_HANDLE_OFFSET_X;

  if (standalone && trailing) {
    offsetX = '0';
  } else if (standalone) {
    offsetX = '50%';
  }

  if (trailing) offsetX = "calc(100% - " + offsetX + ")";
  return getGrippieOffset(offsetX);
}, function (_ref6) {
  var standalone = _ref6.standalone;
  return standalone && standaloneMixin;
}, function (_ref7) {
  var size = _ref7.size;
  return size !== 'default' && sizedMixin;
});

function UIDragHandle(props, context) {
  var children = props.children,
      className = props.className,
      position = props.position,
      size = props.size,
      use = props.use,
      _wrappedWithDnd = props._wrappedWithDnd,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "position", "size", "use", "_wrappedWithDnd"]);
  var connectDragSource = context.connectDragSource;

  if (typeof connectDragSource === 'function' && !_wrappedWithDnd) {
    _devLogger.default.warn({
      message: 'Looks like you’re trying to use UIComponents’ `UIDragHandle` with ui-addon-draggable. Use `ui-addon-draggable/draggable/UIDragHandle` instead.'
    });
  }

  return _react.default.createElement(DragHandleChild, {
    className: (0, _classNames.default)(className, 'is--draggable', {
      'is--draggable--sized': size !== 'default'
    }),
    rest: rest,
    size: (0, _tshirtSize.toShorthandSize)(size),
    standalone: children === emptyBox,
    trailing: position === 'end',
    use: use
  }, children);
}

UIDragHandle.defaultProps = {
  children: emptyBox,
  position: 'start',
  size: 'default',
  use: 'default'
};
UIDragHandle.propTypes = {
  children: _react.PropTypes.element.isRequired,
  position: _react.PropTypes.oneOf(['start', 'end']).isRequired,
  size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm', 'md', 'lg']), _react.PropTypes.oneOf(['default'])]).isRequired,
  use: _react.PropTypes.oneOf(['default', 'on-dark']).isRequired,
  _wrappedWithDnd: (0, _decorators.hidden)(_react.PropTypes.bool)
};
UIDragHandle.contextTypes = {
  connectDragSource: _react.PropTypes.func
};
UIDragHandle.displayName = 'UIDragHandle';
var _default = UIDragHandle;
exports.default = _default;
module.exports = exports.default;